<template>
  <div id="user_training_list_outer" v-if="trainData">
    <div :class="[specifiedBorderColor,]">
      <table class="table table-striped" style="margin-top: 5px;margin-bottom: 20px;">
        <thead>
        <tr>
          <th v-for="(item, index) in thList"
              v-if="showList.indexOf(index) != -1"
              :key="'train_item_th_' + index">{{item}}</th>

        </tr>
        </thead>
        <tbody >
        <tr v-for="(item, index) in trainData" :key="'train_item_td_' + index" >
          <td v-if="showList.indexOf(0) != -1"><a :href="itemSrc(item)" target="_blank">{{$moment(item.startTime).format('YYYY-MM-DD')}}</a></td>
          <td v-if="showList.indexOf(1) != -1"><a :href="itemSrc(item)" target="_blank">{{item.body}}</a></td>
          <td v-if="showList.indexOf(2) != -1">
            <span v-if="item.certificate == null">暂无</span>
            <el-image v-else :src="item.certificate" class="train-certi-img" :preview-src-list="[item.certificate]"></el-image>
          </td>


          <td v-if="showList.indexOf(3) != -1"><a :href="itemSrc(item)" target="_blank">{{trainItemStatus(item)}}</a></td>

          <td v-if="showList.indexOf(4) != -1">

            <el-image v-if="item.status == 1 && item.vx" :src="item.vx" class="train-certi-img" :preview-src-list="[item.vx]"></el-image>
            <span v-else>暂无{{item.vx}}</span>
          </td>
          <td>
            <div class="application-invoice">
              <a v-if="item.applicationStatus == 0" style="pointer-events: none;color: #999;">申请</a>
              <a v-else-if="item.applicationStatus == 1" id="invoice_appli_button" href="javascript:void(null);" @click="getInvoiceButtonClicked(item)">申请</a>
              <a v-else-if="item.applicationStatus == 2" style="pointer-events: none;color: #999;">已提交</a>
<!--              <a v-else-if="item.applicationStatus == 3" style="pointer-events: none;color: #999;">开票中/已寄出</a>-->
              <a class="iconfont" style="font-size: 0.8rem;"
                 href="javascript:void(null);"
                 data-container="body"
                 data-placement="auto right"
                 :data-content="item.popover"
                 data-trigger="hover focus"
                 data-toggle="popover" v-if="item.applicationStatus != 1">&#xe659;</a>
            </div>
          </td>
        </tr>
        </tbody>
      </table>

      <invoice-application-dialog v-if="showInvoiceDialog"
                                  v-on:submitInvoiceData="invoiceSumitClicked"
                                  v-on:close="closeInvoiceDialog"></invoice-application-dialog>
    </div>
  </div>
</template>

<script>
  import InvoiceApplicationDialog from "./InvoiceApplicationDialog";
  import {Loading} from "element-ui";
export default {
  name: "UserTrainingList",
  components: {
    InvoiceApplicationDialog
  },
  data() {
    return {
      thList: [
        '开课时间',
        '课程名称',
        '证书',
        '报名进度',
        '客服微信',
        '发票'
      ],
      trainData: null,
      showInvoiceDialog: false,
      currentItem: null,
      srcList: [
        'https://fuss10.elemecdn.com/8/27/f01c15bb73e1ef3793e64e6b7bbccjpeg.jpeg',
        'https://fuss10.elemecdn.com/1/8e/aeffeb4de74e2fde4bd74fc7b4486jpeg.jpeg',
      ],
      showList: [0,1,2,3,4, 5],
    }
  },
  computed: {
    httpManager() {
      return this.$store.state.http;
    },
    user() {
      return this.$store.state.user;
    },
    isVip() {
      if (this.user == null) {
        return false;
      }
      let user = this.user;
      let memberValidDate = user.memberValidDate;

      if (memberValidDate == null) {
        return false;
      }
      return this.$moment(memberValidDate).add('1','days').add('-1', 'seconds').isAfter(this.$moment());
    },
    specifiedBorderColor() {
      return this.isVip == false ? "shba-no-vips-border-color" : "shba-vips-border-color";
    },
  },
  mounted() {
    this.loadUserOrderData();
    $(window).resize(this.updateStatus);
    this.updateStatus();
  },
  methods: {
    updateStatus() {
      let width = document.body.clientWidth;

      if (width >= 768) {
        this.showList = [0,1,2,3,4,5];
      } else if (width > 500) {
        this.showList = [1,2,3, 5];
      } else {
        this.showList = [1,2,5];
      }

    },

    dealWithListData(listData) {
      if (listData && listData.length > 0) {
        let tmp = [];
        for (let item of listData) {
          item.applicationStatus = this.applicationButtonStatus(item);
          item.popover = this.popoverNotes(item);
          tmp.push(item);
        }
        this.trainData = tmp;
        console.log(this.trainData);
      }

      setTimeout(function () {
        $("[data-toggle='popover']").popover();
      },1000);
    },

    trainItemStatus(item) {
      let status = item.status;
      let step = item.step;
      switch (status) {
        case 0:
          return '审核中';
        case 2:
          if (step == 1) {
            return '待完善防疫承诺书';
          } else if (step == 2) {
            return '待支付';
          }
          return '待支付';
        case 1:
          return '报名成功';
        case 3:
          return '订单过期';
        case 4:
          return '审核未通过';
        default:
          return '暂无';
      }
    },

    applicationButtonStatus(item) {
      // 0 课程未结束，不能点击
      // 1 课程已结束，可以申请发票
      // 2 发票申请成，待寄出
      // 3 发票申请成功，已寄出
      let status = item.status;
      if (status == 1) {
        let endTime = item.endTime;
        if (endTime == null || endTime == '') {
          return 0;
        }
        let now = this.$moment(this.$moment().format('YYYY-MM-DD'), 'YYYY-MM-DD');
        let endDate = this.$moment(endTime);
        if (!endDate.isValid()) {
          return 0;
        }
        if (now - endDate <= 0) {
          return 0;
        }

        let awbStatus = item.awbStatus;
        if (awbStatus == null) {
          return 1;
        }
        if (awbStatus == 0) {
          return 2;
        }
        if (awbStatus == 1) {
          return 3;
        }
      }
      return 0;
    },
    popoverNotes(item) {
      console.log('---1');
      let applicationStatus = item.applicationStatus;
      if (applicationStatus == 0 || applicationStatus == 1) {
        return '培训课程完成后，可申请发票！';
      } else if (applicationStatus == 2) {
        return '预计30个工作日内完成开票，请耐心等待！';
      } else {
        return `发票已寄出，快递单号：${item.awb}`;
      }
    },
    getInvoiceButtonClicked(item) {
      this.showInvoiceDialog = true;
      this.currentItem = item;
    },

    closeInvoiceDialog() {
      this.showInvoiceDialog = false;
    },

    itemSrc(item) {
      return '/training/course/' + item.productId;
    },
    invoiceSumitClicked(res) {
      let params = res;
      params.orderId = this.currentItem.id;
      // console.log(params);
      this.postInvoiceData(params);
    },

    loadUserOrderData() {
      let _this = this;
      this.httpManager.ajax.getUcOrdersData(function (data) {
        let code = data.code;
        if (code == 0) {
          let tempList = data.data;
          let list = [];
          for (let item of tempList) {
            if (item.productId == 0 || item.productId == -1 || item.productId == -2) {
              continue;
            }
            list.push(item);
          }

          _this.$emit('trainDataUpdate', {data: list});
          _this.dealWithListData(list);
        }
      }, function (data) {

      });
    },

    postInvoiceData(params) {
      let loadFlags = Loading.service({
        target: document.getElementById('app'),
        fullscreen: true
      });

      let _this = this;
      this.httpManager.ajax.postUcTaxRequest(params, function (data) {
        loadFlags.close();
        let code = data.code;
        if (code == 0) {
          _this.loadUserOrderData();
          _this.$toast('发票申请成功，请耐心等待！');
          _this.showInvoiceDialog = false;
          _this.currentItem = null;
          return;
        } else if (code == 2) {
          _this.$toast('发票只能申请一次，不能重复申请！');
          return;
        }
        _this.$toast('提交失败！');
      }, function (data) {
        loadFlags.close();
        _this.$toast('提交失败，请重试！');
      });
    },
  }
}
</script>

<style scoped>
  #user_training_list_outer {
    width: 100%;
    padding-top: 30px;
    padding-bottom: 40px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding-left: 5px;
    padding-right: 5px;
  }

  #user_training_list_outer > div {
    width: 100%;
    min-width: 290px;
  }

  #user_training_list_outer th {
    text-align: center;
    vertical-align: middle;
  }

  #user_training_list_outer td {
    text-align: center;
    vertical-align: middle;
  }


  #user_training_list_outer .application-invoice {

  }

  #user_training_list_outer table a {
    color: inherit;
    text-decoration: none;
  }

  #user_training_list_outer #invoice_appli_button {
    color: #333;
    font-size: 1rem;
    font-weight: bold;
  }

  #user_training_list_outer #invoice_appli_button:hover {
    color: #fc1a34;
  }

  #user_training_list_outer .train-certi-img {
    width: 80px;
    height: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/UserTrainingList.vue